import React from 'react';

import Helmet from './Helmet';

const Title = 'The Feedback-Driven Pendo Alternative | Canny';
const Description =
  'Canny is a refreshing alternative to Pendo. Simple, elegant design & sensible pricing. Get started for free!';
const Image = 'https://canny.io/images/canny-social.png';

const LandingPendoHelmet = () => {
  return (
    <Helmet
      title={Title}
      meta={[
        { name: 'description', content: Description },

        { property: 'og:image', content: Image },
        { property: 'og:title', content: Title },
        { property: 'og:description', content: Description },
        { property: 'og:url', content: 'https://canny.io/compare/pendo' },
        { property: 'og:type', content: 'website' },

        { name: 'twitter:card', content: 'summary_large_image' },
        { name: 'twitter:site', content: '@cannyHQ' },
        { name: 'twitter:title', content: Title },
        { name: 'twitter:description', content: Description },
        { name: 'twitter:image', content: Image },
      ]}
    />
  );
};
export default LandingPendoHelmet;
